import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/exchanges/[slug]/ExchangePageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/exchanges/FeeCostCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/exchanges/VolumeTierCalculator.tsx");
